import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PresalesRaidItem {
  id: string;
  presalesProjectId: string;
  itemNumber: string;
  type: string;
  description: string;
  identifiedDate: string;
  impact: string;
  owner: string;
  targetDate?: string;
  status: string;
  mitigationPlan?: string;
  dateClosed?: string;
  remark?: string;
}

export interface CreatePresalesRaidItemDto {
  presalesProjectId: string;
  itemNumber: string;
  type: string;
  description: string;
  identifiedDate: string;
  impact: string;
  owner: string;
  targetDate?: string;
  status: string;
  mitigationPlan?: string;
  dateClosed?: string;
  remark?: string;
}

@Injectable({ providedIn: 'root' })
export class PresalesRaidItemService {
  private apiUrl = `${environment.apiUrl}/PresalesRaidItem`;

  constructor(private http: HttpClient) {}

  getByPresalesProjectId(presalesProjectId: string): Observable<PresalesRaidItem[]> {
    return this.http.get<PresalesRaidItem[]>(`${this.apiUrl}/presales-project/${presalesProjectId}`);
  }

  addItem(item: CreatePresalesRaidItemDto): Observable<PresalesRaidItem> {
    return this.http.post<PresalesRaidItem>(this.apiUrl, item);
  }

  updateItem(id: string, item: PresalesRaidItem): Observable<PresalesRaidItem> {
    return this.http.put<PresalesRaidItem>(`${this.apiUrl}/${id}`, item);
  }

  deleteItem(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
